<script>
	export let disabled = false;

	let className = $$props.class ? " " + $$props.class : "";
	let style = $$props.style ? " " + $$props.style : "";
</script>

<button class={className} {style} on:click|preventDefault {disabled} type="submit">
	<slot></slot>
</button>

<style>
	button {
		color: var(--color-body);
		background-color: transparent;
		border: none;
		padding: 0;
		font-family: "Proxima Nova";
		font-size: 18px;
		font-weight: 600;
		font-weight: bold;
	}

	button:hover {
		color: var(--color-primary);
	}
</style>
